/**
 * Curated outbound webhook subscribe catalog for Tenant Staff UI.
 * Subset of standard + logistics-workflow plugin events — not the full
 * STANDARD_EVENT_NAMES list (FE must not import apps/api).
 */
export const WEBHOOK_SUBSCRIBE_EVENTS = [
  "webhook.ping",
  "ticket.created",
  "ticket.message_added",
  "ticket.status_changed",
  "ticket.assigned",
  "ticket.closed",
  "ticket.read_by_support",
  "announcement.published",
  "announcement.unpublished",
  "announcement.read",
  "order_service.created",
  "order_service.updated",
  "order_service.status_changed",
  "order_service.completed",
  "order_service.cancelled",
  "order_service.closed",
  "document.uploaded",
  "document.replaced",
  "document.deleted",
  "document.requested",
  "workflow_step.status_changed",
  "workflow_step.completed",
] as const;

export type WebhookSubscribeEvent = (typeof WEBHOOK_SUBSCRIBE_EVENTS)[number];
